.emptyListContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-0);
  padding: var(--pgm-sys-spacing-8);
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: var(--pgm-sys-spacing-2);
  color: var(--pgm-sys-color-on-surface-variant);
  text-align: center;
}
